import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { CheckBoxComponent } from '@shared/components/check-box/check-box.component';
import { SafeHtmlPipe } from '@shared/pipes/safe-html.pipe';

@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html',
  imports: [TranslateModule, CommonModule, CheckBoxComponent, SafeHtmlPipe],
})
export class ConfirmationComponent {
  @ViewChild('modalRef') modalRef: ElementRef;
  @Input() title = 'Confirmation';
  @Input() message: string;
  @Input() confirmLabel = 'Ok';
  @Input() cancelLabel = 'Cancel';
  @Input() isLeaveSite: boolean;
  @Input() isHtmlMessage = false;
  @Input() checkboxConfirmMessage: string;
  @Input() shouldShowFooter = true;
  @Input() confirmBtnDisplayed = true;
  @Input() compact = false;

  isConfirmMessage: boolean;

  constructor(public activeModal: NgbActiveModal) {}

  confirm(): void {
    this.activeModal.close(true);
  }
  cancel(): void {
    this.activeModal.close(false);
  }
  setCheckboxValue(value: boolean): void {
    this.isConfirmMessage = value;
  }
}
